import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Services from '../services/services';
import BodyContainer from '../ui/BodyContainer';
import CustomButton from '../ui/viewEventUi/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Select from 'react-select';
import Checkbox from '@material-ui/core/Checkbox';
import newEventStyles from '../styles/newEventStyles';
import toast, { Toaster } from 'react-hot-toast';
import format from 'date-fns/format';
import { KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import Loader from '../ui/Loader';
import Typography from '@material-ui/core/Typography';

import { cancelledEventStatus, defaultImages } from '../constants';

import CardMedia from '@material-ui/core/CardMedia';

import TimezoneSelect from 'react-timezone-select';
import TextFieldComp from './../ui/TextFieldComp';
import AttachFileSharpIcon from '@material-ui/icons/AttachFileSharp';
import InputAdornment from '@material-ui/core/InputAdornment';
import CustomPickerIcon from './../ui/CustomPickerIcon';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateNewEventForm,
  updateEditEventForm,
  clearForm,
} from './../redux/newEventSlice';

import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { getUserBrowserStorage } from '../constants';
import { backArrow } from '../ui/icons';
import CustomDialog from '../ui/customDialog';

const useStyles = makeStyles((theme) => newEventStyles(theme));

const events = [
  { value: 'concert', label: 'Concert', id: 1 },
  { value: 'conference', label: 'Conference', id: 2 },
  { value: 'fundraiser', label: 'Fundraiser', id: 3 },
  { value: 'party', label: 'Party', id: 4 },
  { value: 'religious', label: 'Religious', id: 5 },
  { value: 'sports', label: 'Sports', id: 6 },
  { value: 'wedding', label: 'Wedding', id: 7 },
];

function NewEvent() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const newEvent = useSelector((state) => state.newEvent);

  const eventDataValues = location.state?.data;

  const IVSStreamURL =
    'https://5bfbb37e8976.us-east-1.playback.live-video.net/api/video/v1/us-east-1.343878191130.channel.DDFdP1KJGTVJ.m3u8'; //live
  // 'https://5bfbb37e8976.us-east-1.playback.live-video.net/api/video/v1/us-east-1.343878191130.channel.7vOlZuuj57UL.m3u8'; //--2gathers website
  // 'https://785e05032bc0.us-east-1.playback.live-video.net/api/video/v1/us-east-1.593002333172.channel.HYxFJ1lLg2g5.m3u8'; //--test and dev

  const defaultStreamURL = location.state?.data?.eventStreamUrl || IVSStreamURL;
  const [checked, setChecked] = useState(1);
  const [checkedPublic, setCheckedPublic] = useState(false);
  const [checkedUsers, setCheckedUsers] = useState(false);
  const [checkedGuestUsers, setCheckedGuestUsers] = useState(false);
  // const [checkedReserveBox, setCheckedReserveBox] = useState(false);

  const [layoutDetails, setLayoutDetails] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [loader, setLoader] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [errors, setErrors] = useState({});
  const [getEventType, setEventType] = useState('');

  const [imageChk, setImageChk] = useState();
  const [eventLayout, setEventLayout] = useState();
  const [eventBanner, setEventBanner] = useState();

  const [selectedTimezone, setSelectedTimezone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));

  const clearErrors = () => {
    setErrors({});
  };

  const handleChange = (event) => {
    setEventLayout();
    setChecked(event.target.value);
  };

  const handleChangePublic = (event) => {
    setCheckedPublic(event.target.checked);
    setCheckedUsers(false);
  };

  const handleChangeUsers = (event) => {
    setCheckedUsers(event.target.checked);
  };

  const handleChangeGuestUser = (event) => {
    setCheckedGuestUsers(event.target.checked);
  };

  // const handleChangeReserveBox = (event) => {
  //   setCheckedReserveBox(event.target.checked);
  // };

  const handleChangeEventType = (selectedOption) => {
    clearErrors();
    setEventType(selectedOption);
  };

  const convert = (str) => {
    const dateString = str;
    const result = format(dateString, 'yyyy-MM-dd');
    return result;
  };

  const convertTime = (orgDate) => {
    const result = format(new Date(orgDate), 'HH:mm:ss');
    return result;
  };

  const handleDateChange = (date) => {
    clearErrors();
    setSelectedDate(date);
  };

  const handleTimeChange = (time) => {
    clearErrors();
    setSelectedTime(time);
  };

  const convertDateTimeToUTC = (date, time, zone) => {
    const convertedDate = convert(date);
    const convertedTime = convertTime(time);

    const actualDate = zonedTimeToUtc(
      convertedDate + ' ' + convertedTime,
      zone
    );

    // (actualDate, 'actual date conv to utc');

    const sendDate = `${actualDate.getUTCFullYear()}-${
      actualDate.getUTCMonth() + 1
    }-${actualDate.getUTCDate()}`;

    const sendTime = `${actualDate.getUTCHours()}:${actualDate.getUTCMinutes()}`;
    // (sendDate, 'actual date conv to utc', sendTime);

    return { sendDate: sendDate, sendTime: sendTime };
  };

  const uploadImgFunc = async (e, label) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    } else {
      switch (label) {
        case 'icon':
          setImageChk(file);
          break;

        case 'layout':
          setChecked();
          setEventLayout(file);
          break;

        case 'banner':
          setEventBanner(file);
          break;

        default:
          break;
      }
    }
    return;
    // setImageChk(file);
  };

  const handleCancel = () => {
    if (eventDataValues) {
      history.goBack();
    }
    history.push('/');
  };

  const handleCancelEvent = () => {
    setLoader(!loader);
    Services.update_event_status(cancelledEventStatus, eventDataValues?.eventId)
      .then((eventResponse) => {
        if (eventResponse.data.responseCode === 200) {
          setLoader(false);
          toast.success(eventResponse.data.details, { duration: 5000 });
          history.push('/');
        } else {
          setLoader(false);
          toast.error(eventResponse.data.details, { duration: 5000 });
        }
      })
      .catch((err) => {
        setLoader(false);
        toast.error('failed', { duration: 5000 });
      });
  };

  const handleTextChange = (event) => {
    clearErrors();
    dispatch(
      updateNewEventForm({
        name: event.target.name,
        value: event.target.value,
      })
    );
  };

  const validationFunc = () => {
    let errors = {};
    if (!newEvent.eventName) {
      errors.eventName = 'Event name is required';
    }
    if (!newEvent.eventDescription) {
      errors.eventDescription = 'Description is required';
    }
    if (!newEvent.eventCapacity) {
      errors.eventCapacity = 'Atleast one participant is required';
    } else if (newEvent.eventCapacity < 1) {
      errors.eventCapacity = 'Atleast one participant is required';
    }
    if (!newEvent.participantPerBox) {
      errors.participantPerBox = 'Participants per box is required';
    } else if (+newEvent.participantPerBox < 1) {
      errors.participantPerBox = 'Atleast one participant is required';
    } else if (+newEvent.participantPerBox > +newEvent.eventCapacity) {
      errors.participantPerBox = `Participants per box can't be greater than event capacity`;
    } else if (+newEvent.participantPerBox > 50) {
      errors.participantPerBox =
        'Participants should be less than or equal to 50';
    }
    if (!newEvent.boxPrice) {
      if (+newEvent.boxPrice !== 0) {
        errors.boxPrice = 'Box price is required';
      }
    }
    if (getEventType?.value !== 'wedding') {
      if (!newEvent.seatPrice) {
        if (+newEvent.seatPrice !== 0) {
          errors.seatPrice = 'Seat price is required';
        }
      }
    }

    if (!getEventType) {
      errors.getEventType = 'Event type is required';
      // setEventError(false);
    }

    if (!selectedDate) {
      errors.selectedDate = 'Event start date is required';
    }

    if (!selectedTime) {
      errors.selectedTime = 'Event start time is required';
    }

    setErrors(errors);
    const errorStatus = Object.keys(errors).length === 0;
    return errorStatus;
  };

  const capitalizeFirstLetterEachWord = (mySentence) => {
    const convertSentence = mySentence.trimEnd().toLowerCase();
    const finalSentence = convertSentence.replace(
      /(^\w{1})|(\s+\w{1})/g,
      (letter) => letter.toUpperCase()
    );
    return finalSentence;
  };

  const getLayout = async () => {
    try {
      const res = await Services.get_layout();
      setLayoutDetails(res.data.layoutDetails);
    } catch (error) {}
  };

  useEffect(() => {
    if (eventDataValues) {
      return null;
    }
    getLayout();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearForm());
    };
  }, []);

  useEffect(() => {
    if (eventDataValues) {
      dispatch(updateEditEventForm({ values: eventDataValues }));
      setEventType([
        {
          value: eventDataValues.eventType,
          label: capitalizeFirstLetterEachWord(eventDataValues.eventType),
        },
      ]);

      const UTCDate = zonedTimeToUtc(
        eventDataValues.eventDate + ' ' + eventDataValues.eventTime,
        'GMT'
      );

      // //for selecting time according to as chosen by host
      // const SelectDate = utcToZonedTime(UTCDate, 'America/Godthab');
      // setSelectedDate(SelectDate);
      // setSelectedTime(SelectDate);
      setChecked(eventDataValues.eventLayoutId_id);
      setCheckedGuestUsers(!!eventDataValues.isGuestAllowed);
      setSelectedDate(UTCDate);
      setSelectedTime(UTCDate);
      setCheckedPublic(eventDataValues.publicEvent === 'Y' ? true : false);
      setCheckedUsers(
        eventDataValues.allowUsersToReserveBox === 'Y' ? true : false
      );
    }
  }, []);

  const totalBoxesFunc = () => {
    const participantPerBox = Number(newEvent?.participantPerBox);
    const eventCapacity = Number(newEvent?.eventCapacity);
    const totalBoxes =
      eventCapacity && participantPerBox
        ? Math.ceil(eventCapacity / participantPerBox)
        : '';
    return totalBoxes;
  };

  useEffect(() => {
    if (newEvent?.participantPerBox || newEvent?.seatPrice) {
      +newEvent?.seatPrice ||
        handleTextChange({ target: { name: 'boxPrice', value: '0' } });
      +newEvent?.seatPrice && BoxPriceFunc();
    }
  }, [newEvent?.participantPerBox, newEvent?.seatPrice]);

  const BoxPriceFunc = () => {
    const participantPerBox = Number(newEvent?.participantPerBox);
    const seatPrice = Number(newEvent?.seatPrice);
    const totalBoxPrice = seatPrice * participantPerBox;
    // seatPrice && participantPerBox
    //   ? Math.ceil(seatPrice * participantPerBox)
    //   : '';
    handleTextChange({ target: { name: 'boxPrice', value: totalBoxPrice } });
    return totalBoxPrice;
  };

  const submitEventForm = async (pageName) => {
    const formValid = validationFunc();

    if (formValid) {
      setLoader(true);
      const formData = new FormData();
      const participantPerBox = Number(newEvent?.participantPerBox);
      const eventCapacity = Number(newEvent?.eventCapacity);
      const totalBoxes =
        eventCapacity && participantPerBox
          ? Math.ceil(eventCapacity / participantPerBox)
          : null;

      const eventDate = convertDateTimeToUTC(
        selectedDate,
        selectedTime,
        selectedTimezone?.value || selectedTimezone
      );

      let getObj = {
        //default stream url
        eventStreamUrl: defaultStreamURL,
        eventType: getEventType.value,
        // eventName: capitalizeFirstLetterEachWord(newEvent.eventName), //newEvent.eventName.trimEnd().toLowerCase()
        eventName: newEvent.eventName.trimEnd(),
        eventDescription: newEvent.eventDescription.trimEnd(),
        [checked ? 'eventLayoutId' : 'dummy']: checked || '',
        eventCapacity: eventCapacity,
        eventStreamingUrlId: 1,
        eventDate: eventDate.sendDate,
        eventTime: eventDate.sendTime,
        totalBox: totalBoxes,
        participantPerBox: participantPerBox,
        boxPrice: newEvent.boxPrice,
        seatPrice: newEvent.seatPrice ? newEvent.seatPrice : 0,
        allowUsersToReserveBox: checkedUsers ? 'Y' : 'N',
        publicEvent: checkedPublic ? 'Y' : 'N',
        location: newEvent.location ? newEvent.location.trimEnd() : '',
        address: newEvent.address ? newEvent.address.trimEnd() : '',
        userId: userDetails?.userId,
        createdBy: userDetails?.userId,
        updatedBy: userDetails?.userId,
        isGuestAllowed: checkedGuestUsers ? 1 : 0,
      };

      let eventService;

      formData.append('eventData', JSON.stringify(getObj));
      formData.append('eventLogo', imageChk);
      formData.append('eventLayout', eventLayout);
      formData.append('eventBanner', eventBanner);

      switch (pageName) {
        case 'edit':
          // eventService = Services.edit_event(eventDataValues.eventId, getObj);
          eventService = Services.edit_event(eventDataValues.eventId, formData);

          break;

        case 'new':
          // formData.append('eventData', JSON.stringify(getObj));
          // formData.append('eventLogo', imageChk);
          // formData.append('eventLayout', eventLayout);
          // formData.append('eventBanner', eventBanner);

          eventService = Services.create_event(formData);
          break;

        default:
          break;
      }

      try {
        const res = await eventService;
        setLoader(false);
        if (res.data.responseCode === 201 || res.data.responseCode === 200) {
          toast.success(res.data.details, { duration: 4000 });
          history.push('/');
          return;
        } else {
          toast.error('Failed to create event', { duration: 4000 });
          return;
        }
      } catch (error) {
        setLoader(false);
        toast.error('Failed to create event', { duration: 4000 });
      }
    }
  };

  const handleBackButton = () => {
    history.goBack();
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <BodyContainer
      title={eventDataValues ? 'Edit Event' : 'Create Event'}
      icon={eventDataValues ? backArrow(handleBackButton) : ''}
    >
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <CustomDialog
            open={dialogOpen}
            handleClose={handleDialogClose}
            handleOk={handleCancelEvent}
            btnOkText='Agree'
            cancelText='Disagree'
            titleText='Cancel Event?'
            contentText='This event will be cancelled and no longer will be available for users.'
            btnOkCls={classes.btnOkCls}
            arrowIconCls={classes.arrowIconCls}
          ></CustomDialog>
          <form className={classes.form}>
            <Grid container alignItems='center' justify='center'>
              <Grid
                item
                container
                xs={12}
                alignItems='flex-start'
                justify='center'
                component='div'
                className={classes.containerRowClass}
              >
                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  alignItems='center'
                  justify='center'
                >
                  <TextFieldComp
                    // disabled={dataFrom === 'UpcomingEvents' ? true : false}
                    name='eventName'
                    label='Name of the event *'
                    placeholder='Name of the event'
                    required={true}
                    error={!!errors?.eventName}
                    helpertext={errors?.eventName}
                    value={newEvent.eventName}
                    onChange={handleTextChange}
                    inputStyles={classes.inputStyles}
                  />
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={6}
                  component='div'
                  className={classes.boxSelectContSpec}
                  alignItems='center'
                  justify='center'
                  style={{ position: 'relative' }}
                >
                  <Select
                    name='eventType'
                    value={getEventType}
                    onChange={handleChangeEventType}
                    options={events}
                    placeholder='Event type *'
                    styles={customStyles}
                  />
                  {errors?.getEventType && (
                    <div className={classes.errorCls}>
                      {errors.getEventType}
                    </div>
                  )}
                </Grid>
              </Grid>
              <Grid
                item
                container
                xs={12}
                alignItems='flex-start'
                justify='center'
                component='div'
                className={classes.containerRowClass}
              >
                <TextFieldComp
                  name='eventDescription'
                  label='Description *'
                  placeholder='Description'
                  error={!!errors?.eventDescription}
                  helpertext={errors?.eventDescription}
                  value={newEvent.eventDescription}
                  onChange={handleTextChange}
                  multiline={true}
                  inputStyles={classes.inputStyles}
                  required={true}
                  minRows={2}
                  maxRows={10}
                />
              </Grid>
              <Grid
                item
                container
                xs={12}
                alignItems='flex-start'
                justify='center'
                component='div'
                className={classes.containerRowClass}
              >
                <Grid
                  item
                  container
                  xs={12}
                  sm={4}
                  direction='row'
                  alignItems='flex-start'
                  justify='center'
                >
                  <TextFieldComp
                    disabled={eventDataValues ? true : false}
                    name='eventCapacity'
                    label='Event capacity *'
                    placeholder='Event capacity'
                    error={!!errors?.eventCapacity}
                    helpertext={errors?.eventCapacity}
                    value={newEvent.eventCapacity}
                    onChange={handleTextChange}
                    inputStyles={classes.inputStyles}
                    alignRight={true}
                  />
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={4}
                  direction='row'
                  alignItems='flex-start'
                  justify='center'
                >
                  <TextFieldComp
                    disabled={eventDataValues ? true : false}
                    name='participantPerBox'
                    label='Participants per box *'
                    placeholder='Participants per box'
                    inputStyles={classes.inputStyles}
                    error={!!errors?.participantPerBox}
                    helpertext={errors?.participantPerBox}
                    value={newEvent.participantPerBox}
                    onChange={handleTextChange}
                    alignRight={true}
                  />
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={4}
                  direction='row'
                  alignItems='flex-start'
                  justify='center'
                >
                  <TextFieldComp
                    disabled={true}
                    name='totalBoxes'
                    label='Total boxes'
                    placeholder='Total boxes'
                    inputStyles={classes.inputStyles}
                    error={!!errors?.totalBoxes}
                    helpertext={errors?.totalBoxes}
                    value={totalBoxesFunc()}
                    alignRight={true}
                  />
                </Grid>
              </Grid>

              <Grid
                item
                container
                xs={12}
                alignItems='flex-start'
                justify='center'
                component='div'
                className={classes.containerRowClass}
              >
                <Grid
                  item
                  container
                  xs={12}
                  sm={4}
                  direction='row'
                  alignItems='flex-start'
                  justify='center'
                >
                  <TextFieldComp
                    name='seatPrice'
                    label='Seat reservation price $*'
                    placeholder='Seat reservation price'
                    error={!!errors?.seatPrice}
                    helpertext={errors?.seatPrice}
                    value={newEvent.seatPrice}
                    onChange={handleTextChange}
                    alignRight={true}
                    InputProps={{
                      startAdornment: newEvent.seatPrice ? (
                        <InputAdornment position='start'>$</InputAdornment>
                      ) : (
                        ''
                      ),
                    }}
                    inputStyles={classes.inputStyles}
                  />
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={4}
                  direction='row'
                  alignItems='flex-start'
                  justify='center'
                >
                  <TextFieldComp
                    // disabled={dataFrom === 'UpcomingEvents' ? true : false}
                    disabled={true}
                    name='boxPrice'
                    label='Box reservation price $*'
                    placeholder='Box reservation price'
                    error={!!errors?.boxPrice}
                    helpertext={errors?.boxPrice}
                    // value={newEvent.boxPrice}
                    value={newEvent.boxPrice}
                    onChange={handleTextChange}
                    alignRight={true}
                    InputProps={{
                      startAdornment: newEvent.boxPrice ? (
                        <InputAdornment position='start'>$</InputAdornment>
                      ) : (
                        ''
                      ),
                    }}
                    inputStyles={classes.inputStyles}
                  />
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={4}
                  direction='row'
                  alignItems='flex-start'
                  justify='center'
                >
                  <TextFieldComp
                    name='location'
                    label='Location'
                    placeholder='Location'
                    inputStyles={classes.inputStyles}
                    error={!!errors?.location}
                    helpertext={errors?.location}
                    value={newEvent.location}
                    onChange={handleTextChange}
                  />
                </Grid>
              </Grid>

              <Grid
                item
                container
                xs={12}
                alignItems='flex-start'
                justify='center'
                component='div'
                className={classes.containerRowClass}
              >
                <Grid
                  item
                  container
                  xs={12}
                  sm={4}
                  direction='row'
                  alignItems='flex-start'
                  justify='center'
                  style={{ paddingLeft: 5, paddingRight: 5 }}
                >
                  <TimezoneSelect
                    value={selectedTimezone}
                    onChange={setSelectedTimezone}
                    labelStyle='original'
                    styles={customStyles}
                  />
                </Grid>

                <Grid
                  item
                  container
                  xs={12}
                  sm={4}
                  direction='row'
                  alignItems='flex-start'
                  justify='center'
                  style={{ position: 'relative' }}
                >
                  <KeyboardDatePicker
                    fullWidth
                    disablePast
                    className={classes.inputStyles}
                    inputVariant='outlined'
                    margin='none'
                    id='date-picker-dialog'
                    // label="Date *"
                    format='dd-MM-yyyy'
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                      className: classes.calendarIconStyle,
                    }}
                    keyboardIcon={<CustomPickerIcon iconType='calendar' />}
                    InputProps={{
                      readOnly: true,
                      style: { height: '40px', fontSize: '1rem' },
                      placeholder: 'Event start date *',
                    }}
                  />
                  {errors?.selectedDate && (
                    <div className={classes.errorCls}>
                      {errors.selectedDate}
                    </div>
                  )}
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={4}
                  direction='row'
                  alignItems='flex-start'
                  justify='center'
                  style={{ position: 'relative' }}
                >
                  <KeyboardTimePicker
                    fullWidth
                    className={classes.inputStyles}
                    inputVariant='outlined'
                    margin='none'
                    id='time-picker'
                    // label="Time *"
                    value={selectedTime}
                    onChange={handleTimeChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change time',
                      className: classes.calendarIconStyle,
                    }}
                    keyboardIcon={<CustomPickerIcon iconType='watch' />}
                    InputProps={{
                      readOnly: true,
                      style: { height: '40px', fontSize: '1rem' },
                      placeholder: 'Event start time *',
                    }}
                  />
                  {errors?.selectedTime && (
                    <div className={classes.errorCls}>
                      {errors.selectedTime}
                    </div>
                  )}
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid
                item
                container
                xs={12}
                component='div'
                direction='column'
                alignItems='flex-start'
                justify='center'
                className={classes.boxSelectCont}
              >
                <label htmlFor='icon_event'>
                  <Typography variant='caption' className={classes.typoHeading}>
                    {eventDataValues ? 'EVENT ICON' : 'ATTACH EVENT ICON'}
                  </Typography>
                  {eventDataValues ? (
                    <CardMedia
                      component='img'
                      alt='event_icon'
                      image={
                        imageChk
                          ? URL.createObjectURL(imageChk)
                          : eventDataValues?.eventLogoUrl
                          ? Services.event_logo_URL() +
                            eventDataValues.eventLogoUrl
                          : defaultImages.logo
                      }
                      title='event_icon'
                      className={classes.imageIcon}
                    />
                  ) : (
                    ''
                  )}
                  <>
                    <input
                      hidden
                      accept='image/*'
                      onChange={(e) => uploadImgFunc(e, 'icon')}
                      id='icon_event'
                      name='image'
                      type='file'
                    />
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                      }}
                    >
                      <AttachFileSharpIcon
                        className={classes.attachIconStyle}
                      />
                      <Typography
                        variant='caption'
                        className={classes.choseTextClass}
                      >
                        {imageChk ? imageChk?.name : 'choose file'}
                      </Typography>
                    </div>
                  </>
                </label>
              </Grid>
            </Grid>

            <Grid container>
              <Grid
                item
                container
                xs={12}
                component='div'
                direction='column'
                alignItems='flex-start'
                justify='center'
                className={classes.boxSelectCont}
              >
                <label htmlFor='banner_event'>
                  <Typography variant='caption' className={classes.typoHeading}>
                    {eventDataValues ? 'EVENT BANNER' : 'ATTACH EVENT BANNER'}
                  </Typography>
                  {eventDataValues ? (
                    <CardMedia
                      component='img'
                      // alt="event_banner"
                      image={
                        eventBanner
                          ? URL.createObjectURL(eventBanner)
                          : Services.event_logo_URL() +
                            eventDataValues?.eventBanner
                      }
                      // title="event_banner"
                      // className={classes.imageIcon}
                      className='stadiumImg'
                    />
                  ) : null}
                  <>
                    <input
                      hidden
                      accept='image/*'
                      onChange={(e) => uploadImgFunc(e, 'banner')}
                      id='banner_event'
                      name='image'
                      type='file'
                    />
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                      }}
                    >
                      <AttachFileSharpIcon
                        className={classes.attachIconStyle}
                      />
                      <Typography
                        variant='caption'
                        className={classes.choseTextClass}
                      >
                        {eventBanner ? eventBanner?.name : 'choose file'}
                      </Typography>
                    </div>
                  </>
                </label>
              </Grid>
            </Grid>

            {!eventDataValues ? (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  component='div'
                  className={classes.boxSelectCont}
                >
                  <Typography
                    variant='caption'
                    className={classes.typoHeading}
                    gutterBottom
                  >
                    LAYOUT TYPE
                  </Typography>
                  <div className={classes.borderStadiumCls}>
                    <Grid container spacing={2}>
                      {layoutDetails &&
                        layoutDetails.map((layout) => {
                          return (
                            <Grid
                              item
                              xs={12}
                              sm={3}
                              md={3}
                              lg={3}
                              key={layout.layoutId}
                            >
                              <input
                                type='radio'
                                value={layout.layoutId}
                                name='layout'
                                // onClick={handleChange}
                                onChange={handleChange}
                                id={layout.layoutId}
                                checked={checked == layout.layoutId}
                              />
                              <label htmlFor={layout.layoutId}>
                                <img
                                  src={`/assets/images/layout${layout.layoutId}.png`}
                                  alt='stadium'
                                  className='stadiumImg'
                                />
                              </label>
                            </Grid>
                          );
                        })}
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            ) : null}

            <Grid container>
              <Grid
                item
                container
                component='div'
                xs={12}
                direction='column'
                alignItems='flex-start'
                justify='center'
                className={classes.boxSelectCont}
              >
                <label htmlFor='event_layout'>
                  <Typography variant='caption' className={classes.typoHeading}>
                    {eventDataValues ? 'EVENT LAYOUT' : 'ATTACH CUSTOM LAYOUT'}
                  </Typography>

                  {eventDataValues ? (
                    <CardMedia
                      component='img'
                      alt='event_layout'
                      image={
                        eventLayout
                          ? URL.createObjectURL(eventLayout)
                          : eventDataValues?.eventLayoutUrl
                          ? Services.event_logo_URL() +
                            eventDataValues?.eventLayoutUrl
                          : `/assets/images/layout${eventDataValues?.eventLayoutId_id}.png`
                      }
                      title='event_layout'
                      className={classes.imageLayout}
                    />
                  ) : (
                    ''
                  )}
                  <>
                    <input
                      hidden
                      accept='image/*'
                      id='event_layout'
                      name='image'
                      type='file'
                      value={''}
                      // onChange={uploadCustomLayoutFunc}
                      onChange={(e) => {
                        uploadImgFunc(e, 'layout');
                      }}
                    />
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                      }}
                    >
                      <AttachFileSharpIcon
                        className={classes.attachIconStyle}
                      />
                      <Typography
                        variant='caption'
                        className={classes.choseTextClass}
                      >
                        {eventLayout ? eventLayout?.name : 'choose file'}
                      </Typography>
                    </div>
                  </>
                </label>
              </Grid>
            </Grid>

            <Grid container className={classes.boxSelectCont}>
              <Grid item xs={12} sm={6}>
                <Checkbox
                  checked={checkedPublic}
                  value={checkedPublic}
                  onChange={handleChangePublic}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  id='publicCheck'
                />
                <label htmlFor='publicCheck'>Public event</label>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Checkbox
                  checked={checkedUsers}
                  value={checkedUsers}
                  onChange={handleChangeUsers}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  disabled={!checkedPublic}
                  id='revervedBox'
                />
                <label htmlFor='revervedBox'>Allow users to reserve box</label>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Checkbox
                  checked={checkedGuestUsers}
                  value={checkedGuestUsers}
                  onChange={handleChangeGuestUser}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  id='watchEventGuestCheck'
                />
                <label htmlFor='watchEventGuestCheck'>Allow Guests </label>
              </Grid>
              <Grid item xs={12} sm={6}>
                {/* <Checkbox
                  checked={checkedReserveBox}
                  value={checkedReserveBox}
                  onChange={handleChangeReserveBox}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  id="reserveBoxCheck"
                />
                <label htmlFor="reserveBoxCheck">
                  Reserve BOX-1 for myself
                </label> */}
              </Grid>
            </Grid>
            <div className={classes.btnContainer}>
              {eventDataValues ? (
                <CustomButton
                  btnStyle={classes.button1}
                  clickHandle={() => setDialogOpen(true)}
                  btnText={'Cancel Event'}
                />
              ) : (
                <CustomButton
                  btnStyle={classes.button1}
                  clickHandle={handleCancel}
                  btnText={'Cancel'}
                />
              )}

              <CustomButton
                btnStyle={classes.button}
                clickHandle={() =>
                  submitEventForm(eventDataValues ? 'edit' : 'new')
                }
                btnText={'Save'}
              />
            </div>
            <Grid item sm={12}>
              <br />
            </Grid>
          </form>
        </Paper>
        <Loader open={loader} />
        <Toaster position='top-center'></Toaster>
      </Grid>
    </BodyContainer>
  );
}

export default NewEvent;

const customStyles = {
  container: (state) => ({
    ...state,
    width: '100%',
  }),
  menu: (state) => ({
    ...state,
    zIndex: 2,
    marginTop: 0,
    marginBottom: 0,
  }),

  control: (base) => ({
    ...base,
    height: 40,
    width: '100%',
    flex: 1,
    borderColor: '#0000003b',
    borderWidth: 2,
    borderStyle: 'solid',
  }),

  placeholder: (state) => ({
    position: 'absolute',
    color: 'grey',
    // top: 4,
    fontSize: '1rem',
  }),
  indicatorsContainer: (state) => ({
    position: 'absolute',
    // bottom: 4,
    right: 0,
    // fill: '#000',
  }),
  singleValue: (state) => ({
    position: 'absolute',
    fontSize: '1rem',
    // top: 4,
  }),
};
